import { render, staticRenderFns } from "./injuryrecord.vue?vue&type=template&id=535e0600&"
import script from "./injuryrecord.vue?vue&type=script&lang=js&"
export * from "./injuryrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports